export default "__VITE_ASSET__TW4tGIPO__"